module.exports = "/images/cookie_consent.svg?8ab7df76e6f6baa2889221eb458db03c";